import { extendTailwindMerge, twMerge as stockTwMerge } from "tailwind-merge";

/** V2 names tailwind-merge cannot know; tailwind.test.ts holds them to tokens.json. */
export const V2_THEME = {
  text: [
    "stat-lg",
    "display",
    "heading-xl",
    "stat",
    "heading-lg",
    "title",
    "title-sm",
    "heading-md",
    "heading-sm",
    "body-lg",
    "body",
    "body-strong",
    "label-lg",
    "label",
    "label-sm",
    "caption",
    "micro",
  ],
  shadow: [
    "e0",
    "e1",
    "e2",
    "glow",
    "glow-soft",
    "halo",
    "spotlight",
    "overlay",
  ],
  radius: ["sheet", "panel"],
  spacing: [
    "gutter",
    "gap-card",
    "gap-section",
    "gap-title",
    "inset-card",
    "inset-card-sm",
  ],
} as const;

// Tailwind v4 composes sizes with leading-*; preserve their line heights (EAH-2059).
// Postfix size/leading conflicts stay intact so an explicit text-sm/6 still wins.
export const twMerge = extendTailwindMerge({
  override: {
    conflictingClassGroups: {
      "font-size": [],
    },
  },
  extend: {
    theme: {
      text: [...V2_THEME.text],
      shadow: [...V2_THEME.shadow],
      radius: [...V2_THEME.radius],
      spacing: [...V2_THEME.spacing],
    },
    // The legacy surface shadow must still yield to a caller's shadow-none.
    classGroups: {
      shadow: [{ shadow: ["surface"] }],
    },
  },
});

// V2 roles are unknown to the stock config; all other classes keep its conflict rules.
const FALLBACK_PROBE = "leading-[3.14159rem]";
const V2_TEXT_ROLE = new RegExp(
  `(?:^|\\s)text-(?:${V2_THEME.text.join("|")})(?=\\s|/|$)`,
);

export function overridesFallbackLeading(
  classes: string | undefined | null,
): boolean {
  if (!classes) return false;
  if (V2_TEXT_ROLE.test(classes)) return true;
  return !stockTwMerge(`${FALLBACK_PROBE} ${classes}`)
    .split(" ")
    .includes(FALLBACK_PROBE);
}
